export enum ExplainSectionEnum {
  SEARCH = 'Search',
  PRODUCT_ANALYSIS = 'Product Analysis',
  QUERY_ANALYSIS = 'Query Analysis',
}
